<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：页面头部
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="header-container" class="header-container">
		<!-- 使用 router-link 组件来导航. -->
		<!-- 通过传入 `to` 属性指定链接. -->
		<!-- <router-link> 默认会被渲染成一个 `<a>` 标签 -->
		<div class="tipright">
			IOE.TOP
		</div>
		<div id="divHeaderBottom" class="divHeaderBottom" style="">
			<!--
			<div style="padding:0px 15px; align-items: center;">
				<router-link to="/"><el-button icon="el-icon-menu" size="mini"></el-button></router-link>
			</div>
			-->
			<div class="header-logo">
				<div class="header-logo-inner">
					<div style="display: flex;">
						<div class="header-logo-square"></div>
						<div class="header-logo-square"></div>
					</div>
					<div class="header-logo-line"></div>
					<div class="header-logo-line" style="width: 20px;"></div>
				</div>
			</div>
			<div>
				<el-menu
				id="el-menu-top-for-header"
				class="el-menu-top-for-header"
				:default-active="activeIndex2"
				mode="horizontal"
				@select="handleSelect"
				text-color="#DDEEFF"
				background-color="#0099FF"
				active-text-color="#FFFFFF">
					<el-menu-item index="1"><router-link to="/">{{ getPlatForm }}</router-link></el-menu-item>
					<!--<el-menu-item index="2"><router-link to="/home00">Home</router-link></el-menu-item>-->
					<!-- <el-menu-item index="3"><router-link to="/user">控制台</router-link></el-menu-item>
					<el-submenu index="4">
						<template slot="title">监测中心</template>
						<el-menu-item index="4-1"><a class="a-for-header" href="https://www.ele.me" target="_blank">大屏幕1</a></el-menu-item>
						<el-menu-item index="4-2"><a class="a-for-header" href="https://www.ele.me" target="_blank">大屏幕2</a></el-menu-item>
						<el-menu-item index="4-3"><a class="a-for-header" href="https://www.ele.me" target="_blank">大屏幕3</a></el-menu-item>
					</el-submenu>
					<el-menu-item index="5" disabled>大屏显示</el-menu-item>
					<el-submenu index="5">
						<template slot="title">监测中心</template>
						<el-menu-item index="5-1">监测数据</el-menu-item>
						<el-menu-item index="5-2">溯源分析</el-menu-item>
					</el-submenu>-->
					<!-- 
						含有子项的菜单 
					-->
					<el-submenu 
						v-for="item in get_myMenus_hasChildrenTop" 
						:key="item.name" 
						:index="item.name"
						class="custom-submenu">
						<template slot="title">
							<i :class="`el-icon-${item.icon} menu-icon`"></i>
							<span slot="title" class="menu-text">{{ item.meta.label }}</span>
						</template>
						<el-menu-item-group 
							v-for="subitem in item.children" 
							:key="subitem.name"
							class="submenu-group">
							<router-link :to="`${subitem.path}`" target="_blank">
							<el-menu-item
								:index="subitem.name">
								<!-- <i :class="`el-icon-${subitem.icon} submenu-icon`"></i>
								<span slot="title" class="submenu-text">{{subitem.meta.label}}</span> -->
									<i :class="`el-icon-${subitem.icon} submenu-icon`"></i>
									<span slot="title" class="submenu-text" style="color:#ffffff;">{{subitem.meta.label}}</span>
							</el-menu-item> 
							</router-link>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="6">
						<template slot="title">
							<i class="el-icon-wind-power menu-icon"></i>
							<span slot="title" class="menu-text">关于</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="6-1"
							class="submenu-group">
								<router-link to="/About">
									<i class="el-icon-share submenu-icon"></i>
									<span class="submenu-text" style="color:#ffffff;">我们</span>
								</router-link>
							</el-menu-item>
							<div style="height:15px;"></div>
							<el-menu-item index="6-2"
							class="submenu-group">
								<router-link to="/AboutUS">
									<i class="el-icon-cloudy submenu-icon"></i>
									<span class="submenu-text" style="color:#ffffff;">运营中心</span>
								</router-link>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			<div>
			</div>
		</div>
	</div>
</template>
<script>
//import { getCurInfo } from '../api'

// 输出元素
export default {
	name: 'header-container',
	props: ['userInfo'],
	data() {
		return {
			activeIndex2: '1',
			//myPlatForm ="广电平台",
		};
	},
	methods: {
		handleSelect(key, keyPath) {
			//console.log(key, keyPath);
		},
	},
	mounted() {
		//console.log(this.get_myMenus_hasChildrenTop);
		//console.log(this.menuData);
	},
	computed: {
		getPlatForm() {
			let u = this.$utils.getCurInfo();
			return u.platform;
		},
		get_myMenus_hasChildrenTop() {
			//return this.menuData;
			return this.menuData.filter(item => { 
				//if()
				//if(item.children && item.top == 3) console.log("item:", item);
				return item.children && item.top == 3 });
		},
		// 动态获得数据，与原数组 menuData 同名
		menuData() {
			//const curUserMenu = Cookies.get('curUserMenu');
			const curUserMenu = localStorage.getItem('curUserMenu');
			//console.log(curUserMenu);
			if(curUserMenu) {
				const menu = JSON.parse(curUserMenu);

				//console.log("menu:",menu);
				return menu;
			}
			else
			{
				return false;
			}
		}
	},
}
/*
// 增强背景渐变效果 - 动态改变渐变色
document.addEventListener('DOMContentLoaded', function() {
	const header = document.querySelector('.header-container');
	const colors = [
		['#3399FF', '#3366CC', '#3388EE'],
		['#3399FF', '#2277DD', '#44AAFF'],
		['#3399FF', '#4455BB', '#22AAEE']
	];
	
	let currentColorSet = 0;
	
	// 每30秒切换一次渐变颜色组合
	setInterval(() => {
		currentColorSet = (currentColorSet + 1) % colors.length;
		const newColors = colors[currentColorSet];
		
		header.style.background = `linear-gradient(120deg, ${newColors[0]}, ${newColors[1]}, ${newColors[2]})`;
		header.style.backgroundSize = '400% 400%';
	}, 30000);
});
*/
</script>
<style lang="less">
@keyframes techGlow {
  0% { box-shadow: 0 0 5px rgba(0, 195, 255, 0.7); }
  50% { box-shadow: 0 0 20px rgba(0, 195, 255, 0.9), 0 0 30px rgba(0, 150, 255, 0.6); }
  100% { box-shadow: 0 0 5px rgba(0, 195, 255, 0.7); }
}

@keyframes circuitFlow {
  0% { background-position: 0 0; }
  100% { background-position: 100px 100px; }
}

.el-menu-top-for-header {
	background-color: transparent;
	border-bottom: none;
	
	.el-menu-item, .el-submenu__title {
		position: relative;
		overflow: hidden;
		transition: all 0.3s ease;
		margin: 0 5px;
		border-radius: 4px;
		
		&:hover {
			background: rgba(255, 255, 255, 0.1) !important;
		}
		
		&.is-active {
			background: rgba(255, 255, 255, 0.15) !important;
			
			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
				width: 30px;
				height: 2px;
				background: #00FFFC;
				border-radius: 1px;
			}
		}
	}
}

.a-for-header {
	color: #f0f7ff;
}

.menu-icon {
	color: #ffffff !important;
}

.submenu-icon {
	color: #ffffff !important;
}

.divHeaderBottom {
	position:absolute;
	top:50px;
	left:10px;
	width:100%;
	display:flex;
	align-items: center;
	z-index: 2;
}

.header-container {
    height: 120px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: linear-gradient(125deg, #1a5fb4 0%, #2a7bda 50%, #1a5fb4 100%);
    box-shadow: 
        0 4px 20px rgba(0, 100, 200, 0.4),
        inset 0 0 100px rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    padding: 0 40px;
    color: white;
    border-bottom: 1px solid rgba(100, 180, 255, 0.3);
}

/* 科技感背景效果 */
.header-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
        linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
        radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
        radial-gradient(circle at 80% 70%, rgba(200, 230, 255, 0.2) 0%, transparent 50%);
    background-size: 25px 25px, 25px 25px, 250px 250px, 200px 200px;
    opacity: 0.4;
    /* animation: circuitFlow 15s linear infinite; */
    pointer-events: none;
    mix-blend-mode: overlay;
}

@keyframes circuitFlow {
    0% { 
        background-position: 0 0, 0 0, 0 0, 0 0;
    }
    100% { 
        background-position: 25px 25px, 25px 25px, 100px 100px, 80px 80px;
    }
}

/* Logo样式 */
.header-logo {
	width: 61px;
	height: 61px;
	background: linear-gradient(135deg, rgba(0, 153, 255, 0.8) 0%, rgba(0, 120, 215, 0.9) 100%);
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
	box-shadow: 0 0 20px rgba(0, 150, 255, 0.5);
	position: relative;
	overflow: hidden;
	border: 1px solid rgba(0, 200, 255, 0.5);
	/* animation: techGlow 3s infinite; */
}

.tipright {
	position: absolute;
	top:86px;
	right:10px;
	align-items: center;
	padding: 2px 10px;
	border-radius: 4px;
	height: 24px;
	background: linear-gradient(135deg, rgba(0, 153, 255, 0.8) 0%, rgba(0, 120, 215, 0.9) 100%);
	display: block;
	box-shadow: 0 0 15px rgba(0, 150, 255, 0.4);
	font-weight: 500;
	font-size: 12px;
	color: #ffffff;
	border: 1px solid rgba(0, 200, 255, 0.5);
	z-index: 2;
	/* animation: techGlow 3s infinite; */
}

.header-logo-inner {
	width: 40px;
	height: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.header-logo-square {
	width: 15px;
	height: 15px;
	background: white;
	margin: 2px;
	border-radius: 3px;
	box-shadow: 0 0 5px rgba(255, 255, 255, 0.8);
}

.header-logo-line {
	width: 30px;
	height: 4px;
	background: white;
	margin: 2px;
	border-radius: 2px;
	box-shadow: 0 0 5px rgba(255, 255, 255, 0.8);
}

/* 响应式调整 */
@media (max-width: 768px) {
	.header-container {
		padding: 0 20px;
		height: 100px;
	}
	
	.divHeaderBottom {
		top: 40px;
	}
	
	.tipright {
		top: 70px;
	}
	
	.header-logo {
		width: 50px;
		height: 50px;
		margin-right: 15px;
	}
	
	.header-logo-inner {
		width: 30px;
		height: 30px;
	}
	
	.header-logo-square {
		width: 12px;
		height: 12px;
	}
	
	.header-logo-line {
		width: 25px;
		height: 3px;
	}
}
</style>